import React from 'react';
import Button from '../../../../../../components/Button';
import { ServiceItemProps } from '../../../../../../models/Service';
import { ProductItemProps } from '../../../../../../models/Product';
import ContainerPage from '../../../../../../components/ContainerPage';
import * as S from './styles';

const doctorIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/illustrations/doctor-initial-assessments.svg';
const ArrowLeft = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/Voltar.svg';

const checkupInfo = {
  title: 'Vamos agendar sua primeira consulta',
  infos: [
    {
      icon: 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/estetoscopio.svg',
      text: 'Agora vamos agendar sua primeira consulta, com o clínico geral.'
    },
    {
      icon: 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/exam-icon.svg',
      text: 'Após a consulta, você deverá realizar os exames solicitados pelo médico.'
    },
    {
      icon: 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/calendar-rouded.svg',
      text: 'Com os exames em mãos, você poderá agendar o retorno com o clínico geral e nossa equipe multidisciplinar.'
    }
  ]
};

const checkupInfoReturn = {
  title: 'Consultas complementares',
  infos: [
    {
      icon: 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/estetoscopio.svg',
      text: 'Agora, você já pode agendar as consultas com cada profissional da equipe multidisciplinar, além do retorno com o Clínico Geral.'
    },
    {
      icon: 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/calendar-rouded.svg',
      text: 'Aproveite para agendar todas as consultas de uma vez aqui pelo site ou pelo App Meu Einstein, porque você tem até 90 (noventa) dias para realizá-las.'
    }
  ]
};

export type CheckupDigitalDetailsProps = {
  handleAddProductList: ({
    product,
    service
  }: {
    product: ProductItemProps | undefined;
    service: ServiceItemProps | undefined;
  }) => void;
  service?: ServiceItemProps;
  onClose?: () => void;
  isFirstAppointment: boolean;
};

const CheckupDigitalDetails = ({
  onClose,
  handleAddProductList,
  service,
  isFirstAppointment
}: CheckupDigitalDetailsProps) => {
  const checkupInformations = isFirstAppointment ? checkupInfo : checkupInfoReturn;
  return (
    <ContainerPage
      childrenFooter={
        <Button
          title="Continuar"
          onClick={() => {
            handleAddProductList({ product: undefined, service });
          }}
        />
      }
    >
      <S.CloseWrapper>
        <div onClick={onClose}>
          <S.CloseIcon src={ArrowLeft} alt="Close Icon" />
          <S.CloseTitle>Voltar</S.CloseTitle>
        </div>
      </S.CloseWrapper>
      <S.Container>
        <img className="main-icon" src={doctorIcon} alt="warning" />
        <h3 className="title">{checkupInformations.title}</h3>
        <div className="breadcrumb">
          {checkupInformations.infos.map((item, index) => (
            <div className="row" key={index + item.icon}>
              <div className="line-base">
                <div className="line" />
                <img src={item.icon} />
              </div>
              <p className="info">{item.text}</p>
            </div>
          ))}
        </div>
      </S.Container>
    </ContainerPage>
  );
};
export default CheckupDigitalDetails;
